import './wdyr';
import React from 'react';
import { createRoot } from 'react-dom/client';
import RouterWithProvider from './RouterWithProvider';
import './utils/i18nInit';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { init as initApm } from '@elastic/apm-rum';

initApm({
  serviceName: 'mobileapp',
  serverUrl: process.env.REACT_APP_APM_HOSTNAME,
  serviceVersion: process.env.REACT_APP_VERSION,
});

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <RouterWithProvider />
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
